/**
 * Que ações o cartão de disponibilidade pode oferecer, decididas pelo MOTIVO.
 *
 * Regra dura: um problema de localidade nunca abre o seletor de data/hora,
 * e "Manter apenas <localidade>" nunca repete exatamente o mesmo pedido.
 */

import { failureReasonGroup, type RequestFailureReason } from "./request-failure-reason";

export type AvailabilityCardActions = {
  /** "Escolher outro dia ou hora" e alternativas de horário. */
  time: boolean;
  /** "Alargar para <zona concreta>". */
  widen: boolean;
  /** "Manter apenas <localidade>": fixa a zona, não regenera. */
  keepStrict: boolean;
  /** "Reformular o pedido". */
  rewrite: boolean;
};

export function availabilityCardActions(input: {
  reasons: RequestFailureReason[];
  hasSuggestedArea: boolean;
  keepStrict?: boolean;
}): AvailabilityCardActions {
  const groups = new Set(input.reasons.map(failureReasonGroup));
  const hasSchedule = groups.has("schedule");
  const hasArea = groups.has("area") || groups.has("not_found");
  if (input.keepStrict) {
    return {
      time: hasSchedule,
      widen: input.hasSuggestedArea,
      keepStrict: false,
      rewrite: true,
    };
  }
  return {
    time: hasSchedule,
    widen: hasArea && input.hasSuggestedArea,
    keepStrict: hasArea,
    rewrite: false,
  };
}
